import { useEffect, useCallback } from 'react'
import { processNewEmailEvents, getLeadEmailProviderStats } from '@/lib/lead-email-provider-service'

// Hook to automatically process new email events (all types)
export function useLeadEmailProviderService() {
  const processNewEvents = useCallback(async () => {
    try {
      await processNewEmailEvents()
    } catch (error) {
      console.error('❌ Error in useLeadEmailProviderService:', error)
    }
  }, [])

  // Process new events every 5 minutes
  useEffect(() => {
    // Initial processing
    processNewEvents()

    // Set up interval for ongoing processing
    const interval = setInterval(processNewEvents, 5 * 60 * 1000) // 5 minutes

    return () => clearInterval(interval)
  }, [processNewEvents])

  return {
    processNewEvents,
    getLeadEmailProviderStats
  }
}

// Hook to get lead email provider statistics for a campaign
export function useLeadEmailProviderStats(campaignId?: number) {
  const getStats = useCallback(async () => {
    try {
      return await getLeadEmailProviderStats(campaignId)
    } catch (error) {
      console.error('❌ Error getting lead email provider stats:', error)
      return { total: 0, gmail: 0, outlook: 0, yahoo: 0, other: 0, unknown: 0 }
    }
  }, [campaignId])

  return { getStats }
}
